export default "__VITE_ASSET__ec7cdd0a__"